import { isServer } from '@utils/server'

export function withClientSide<T extends (...args: any) => any>(
  callback: T
): undefined | ReturnType<T> {
  if (isServer()) return undefined

  return callback()
}
